// ============================================================================
// CHANGO V5.0 — 403 Forbidden landing
// ============================================================================
// Rendered when <RoleGate> bounces a user whose role lacks permission.
// Gives a clear explanation + a safe link back.
//
// Task #55: accept `homeHref` / `homeLabel` props the same way NotFound does,
// so the per-SPA route table can point to a path that actually exists in
// that bundle. Default `/` resolves correctly in every bundle via the
// BrowserRouter root Navigate.
// ============================================================================

import React from 'react';
import { Link } from 'react-router-dom';

import { useAuth } from '../hooks/useAuth.js';

export default function Forbidden({ homeHref = '/', homeLabel = '回到首页' }) {
  const { user } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="card max-w-md p-8 text-center">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-50 text-red-600">
          <span className="text-xl font-bold" aria-hidden="true">!</span>
        </div>
        <h1 className="text-xl font-semibold text-slate-800">访问被拒绝</h1>
        <p className="mt-3 text-sm text-slate-600">
          您的角色（<span className="font-mono">{user?.role || '未登录'}</span>）
          没有权限访问当前页面。
        </p>
        <p className="mt-2 text-xs text-slate-500">
          若您认为这是误报，请联系工作区 boss 管理成员权限。
        </p>
        <div className="mt-6 flex justify-center gap-3 text-sm">
          <Link to={homeHref} className="btn-primary">{homeLabel}</Link>
        </div>
      </div>
    </div>
  );
}
